module.exports = __webpack_public_path__ + "media/images/season-3-podcast-d7925710b7245c352b0af5dd66eb217d.jpg";